import * as React from 'react';
import { getSafetyInspectionActivities } from '../../../api/activityClientApi';

import { P, Small } from '../../../designSystem/typography/Body';
import { H3 } from '../../../designSystem/typography/Heading';
import { DashboardCard } from './DashboardCard';
import { Link } from '../../../designSystem/Link';
import { appUrlBuilder } from '../../../utils/appUrlBuilder';
import { DashboardCardContent } from './DashboardCardContent';

export function DashboardSafetyInspectionCard(): JSX.Element {

    const [safetyInspections, setSafetyInspections] = React.useState([]);
    const [status, setStatus] = React.useState("");

    React.useEffect(()=>{
        const getData = async () => {
            const activities = await getSafetyInspectionActivities();
            const now = new Date();
            
            const activitiesPresent = activities
                .filter(a => new Date(a.start) <= now && new Date(a.end) >= now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
            
            const futureActivities = activities
                .filter(a => a.start && new Date(a.start) > now)
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

            if(activitiesPresent.length > 0){
                setStatus("present");
                setSafetyInspections(activitiesPresent);
                
            } else {
                setStatus("future");
                setSafetyInspections(futureActivities);
            }
            
        };
        getData();

    },[])
    
    
    return (
        <DashboardCard backgroundIcon="fact_check" backgroundColor="white">
            {safetyInspections.length > 0 ? (
                <DashboardCardContent 
                    title="Rundering"
                    activityStatus={status === "present" ? `Nuværende rundering ${safetyInspections[0].start.toLocaleDateString()} - ${safetyInspections[0].end.toLocaleDateString()}` : `Kommende rundering ${safetyInspections[0].start.toLocaleDateString()} - ${safetyInspections[0].end.toLocaleDateString()}`}
                    activityLink={appUrlBuilder.safetyInspection.internal(safetyInspections[0].id)}
                    activityTitle={safetyInspections[0].title}
                />
            ) : (
                <DashboardCardContent 
                    title="Rundering"
                    activityStatus="Ingen kommende runderinger"
                    activityLink={appUrlBuilder.safetyInspection.list()}
                    activityTitle="Opret en rundering"
                    createNew={true}
                />
            )}
        </DashboardCard>
    );
}